import React from "react";
import Layout from "../components/Layout";
import MetaTags from "../lib/MetaTags";
import Breadcrumbs from "../components/Breadcrumbs";

export default function Privacy() {
  return (
    <Layout>
      <MetaTags title="Privacy Policy" description="Privacy Policy for Chicago Electronics Guide." />
      <section className="ceg-container py-12">
        <Breadcrumbs items={[{ to: "/", label: "Home" }, { label: "Privacy" }]} />
        <h1 className="font-['Outfit'] font-black tracking-tighter text-5xl md:text-6xl mt-4">Privacy Policy</h1>
        <p className="text-sm text-[#5C5C5C] mt-2">Last updated: February 1, 2026</p>

        <div className="article-prose mt-8 max-w-3xl">
          <p>Chicago Electronics Guide ("we", "our", "us") respects your privacy. This policy explains what information we collect, how we use it, and the choices you have.</p>
          <h2>Information we collect</h2>
          <p>We collect minimal information necessary to operate the site:</p>
          <ul>
            <li><strong>Contact form data</strong> (name, email, message) submitted voluntarily</li>
            <li><strong>Newsletter email addresses</strong> if you subscribe</li>
            <li><strong>Anonymous analytics</strong> (page views, referrers) via Google Analytics if enabled</li>
            <li><strong>Standard server logs</strong> (IP, user agent) for security and abuse prevention</li>
          </ul>
          <h2>How we use information</h2>
          <ul>
            <li>To respond to your inquiries</li>
            <li>To send you the weekly newsletter if you've subscribed</li>
            <li>To understand traffic patterns and improve content</li>
            <li>To protect the site against abuse</li>
          </ul>
          <h2>Cookies and advertising</h2>
          <p>We use minimal first-party cookies for site functionality. If Google AdSense is enabled, third-party cookies may be served to deliver relevant advertising in accordance with Google's policies. You can manage advertising preferences via Google's Ad Settings.</p>
          <h2>Sharing</h2>
          <p>We do not sell personal information. We share data only with service providers who help us operate the site (e.g., hosting, analytics, email delivery), and only as necessary.</p>
          <h2>Your rights</h2>
          <p>You can request access to or deletion of your information by emailing us via the Contact page. Newsletter subscribers can unsubscribe at any time via the link in each email.</p>
          <h2>Children</h2>
          <p>This site is not directed at children under 13. We do not knowingly collect data from children.</p>
          <h2>Changes</h2>
          <p>We may update this policy occasionally. Material changes will be noted on this page with an updated date.</p>
        </div>
      </section>
    </Layout>
  );
}
